var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"selectable-entity-map"},[_c('EntityMap',{attrs:{"coordinates-list":_vm.coordinatesList,"selectedEntities":_vm.selectedEntities},on:{"selected":placeId => _vm.$emit('selected', placeId)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }